/* @ngInject */
export default class CritrereTextController {
    constructor() {}
    $onInit() {}
    $onDestroy() {}
}
